import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import getStockInfoFromStore from 'lib/api/stores'
import FindThisItemModal from './modal'
import styles from './styles.scss'
import { getAvailableStoreFromSizeOption, handleOpenStoreModal } from './utils'

const FindThisItemAtStoreCTA = ({
  product,
  selectedOption,
  setOptionMessage,
  t,
}) => {
  const [stockInfo, setStockInfo] = useState([])
  const [storeAvailable, setStoreAvailable] = useState([])
  const [storeAvailableFromSearch, setStoreAvailableFromSearch] = useState(null)
  const [shouldOpenStoreModal, setShouldOpenStoreModal] = useState(false)
  const isEnableFindItemFeature = Boolean(product?.id_product)

  useEffect(() => {
    const fetchStockInfoFromStore = async () => {
      try {
        const productStock = await getStockInfoFromStore(product.id_product)
        if (productStock?.stores) {
          setStockInfo(productStock.stores)
        }
      } catch (err) {
        setStockInfo([])
      }
    }

    setStockInfo([])
    if (isEnableFindItemFeature) {
      fetchStockInfoFromStore()
    }
  }, [isEnableFindItemFeature, product?.id_product])

  useEffect(() => {
    if (selectedOption && stockInfo) {
      getAvailableStoreFromSizeOption({
        selectedOption,
        setStoreAvailable,
        stockInfo,
      })
    }
  }, [selectedOption, stockInfo])

  if (!isEnableFindItemFeature || product?.is_coming_soon) {
    return null
  }

  return (
    <React.Fragment>
      <div className="find-pdp-item">
        <style jsx>{styles}</style>
        <Button
          type={BUTTON_TYPES.link}
          onClick={() =>
            handleOpenStoreModal({
              product,
              setShouldOpenStoreModal,
              setOptionMessage,
              stockInfo,
              selectedOption,
              t,
            })
          }
        >
          {hasLocizeTranslation(
            t,
            'FIND_PDP_ITEM_AT_STORE_CTA',
            'Find Item At Store Near Me',
          )}
        </Button>
      </div>
      <FindThisItemModal
        productID={product.id_product}
        shouldOpenStoreModal={shouldOpenStoreModal}
        setShouldOpenStoreModal={setShouldOpenStoreModal}
        setStoreAvailableFromSearch={setStoreAvailableFromSearch}
        stockInfo={storeAvailableFromSearch || storeAvailable}
      />
    </React.Fragment>
  )
}

FindThisItemAtStoreCTA.defaultProps = {
  selectedOption: undefined,
}

FindThisItemAtStoreCTA.propTypes = {
  product: PropTypes.shape({
    id_product: PropTypes.number,
    is_coming_soon: PropTypes.bool,
    stock: PropTypes.shape({
      is_sold_out: PropTypes.bool,
    }),
  }).isRequired,
  selectedOption: PropTypes.shape({
    id_product_attribute: PropTypes.number,
  }),
  setOptionMessage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(FindThisItemAtStoreCTA)
